export const paginatedChunkSize = 10;

export const USERS_TABLE_ROW_HEIGHT_PX = 60;

export const signInRedirectLocalStorageKey = "signInRedirect";
